import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { EventType } from 'common/EventConstants';
import { useApi } from 'client/lib/trpc';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import { useDeploymentStatusTree } from 'client/state/useDeploymentStatusTree';
import { useDeploymentWarning } from 'client/pages/deployment/useDeploymentWarning';
import { DropdownMenu, DropdownMenuItem, type DropdownMenuItemProps } from 'client/components/DropdownMenu';
import { useViewAppBlocker } from './useViewAppBlocker';

type ViewAppMenuItemProps = DropdownMenuItemProps & { stackComponentID: number };

export const ViewAppMenuItem = ({ stackComponentID, ...item }: ViewAppMenuItemProps) => {
  const api = useApi();
  const deploymentID = useDeploymentClientState((state) => state.document?.id);
  const statusTree = useDeploymentStatusTree(deploymentID);
  const { menuItems } = useViewAppBlocker({ deploymentID, host: item.id, href: item.href });

  // Check if all containers belonging to "diploi" are green
  const containers = (statusTree?.containers.items || []).filter((item) => item.stackComponentID === stackComponentID);
  const { isWarningDisplayed } = useDeploymentWarning({ containers });

  const handleOpen = () => {
    if (deploymentID) {
      api.status.eventCreate.mutate({
        eventTypeID: EventType.DEPLOYMENT_HOST_OPEN,
        deploymentID,
        host: item.id,
        reason: 'open',
      });
    }
  };

  if (isWarningDisplayed) {
    return (
      <RadixDropdownMenu.Sub>
        <DropdownMenuItem {...item} href={undefined} onClick={undefined} component={<RadixDropdownMenu.SubTrigger />} />
        <RadixDropdownMenu.Portal>
          <DropdownMenu.Content items={menuItems} component={<RadixDropdownMenu.SubContent />} />
        </RadixDropdownMenu.Portal>
      </RadixDropdownMenu.Sub>
    );
  }

  return <DropdownMenuItem {...item} onClick={handleOpen} />;
};
